import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import CardLeftRight from "../../components/cardleftright";
import { dataListsType } from "../../components/featured-posts";
import AdPage from "../../components/AdPage";
import { DataLists } from "../../dataLists/DataLists";

interface TravelSectionProps {
  travelData: dataListsType[];
  nation: string;
}

const TravelSection = ({ nation, travelData }: TravelSectionProps) => (
  <div className="w-full mb-16 px-8">
    <div className="mb-8 border-b-[1px]">
      <h5 className="uppercase text-xs font-semibold pt-2 pb-2 tracking-widest flex justify-between">
        <span>{nation} Cultural Landscape</span>
        <Link
          className="font-bold text-[#4d5bcc]"
          to={{
            pathname: "/morepage",
            search: `?category=Travel&nation=${encodeURIComponent(
              nation
            )}&label=${encodeURIComponent(`${nation}  Cultural Landscape`)}`,
          }}
        >
          MORE{">>"}
        </Link>
      </h5>
      <span className="block w-14 h-[3px] bg-black"></span>
    </div>
    <div className="w-full flex flex-col gap-y-10">
      <CardLeftRight props={travelData.slice(0, 2)} />
    </div>
  </div>
);

export default function Travel() {
  const [travelData, setTravelData] = useState<{
    China: dataListsType[];
    Indonesia: dataListsType[];
    Japan: dataListsType[];
    Singapore: dataListsType[];
  }>({
    China: [],
    Indonesia: [],
    Japan: [],
    Singapore: [],
  });

  useEffect(() => {
    const allData = DataLists.filter((item) => item.category === "Travel");
    setTravelData({
      China: allData.filter((item) => item.nation === "China"),
      Indonesia: allData.filter((item) => item.nation === "Indonesia"),
      Japan: allData.filter((item) => item.nation === "Japan"),
      Singapore: allData.filter((item) => item.nation === "Singapore"),
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Travel Asia - Explore Cultural Landscapes & Tourist Attractions
        </title>
        <meta
          name="description"
          content="Experience the beauty of Asian travel destinations, featuring cultural landscapes, historic sites, and natural wonders in China, Japan, Indonesia and more."
        />
      </Helmet>
      <Header />
      <Navbar />
      <AdPage />
      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center max-w-[888px] my-8">
          <h1 className="text-3xl font-extrabold px-8 pb-3">Travel</h1>
          {Object.entries(travelData).map(([nation, data]) => (
            <TravelSection key={nation} nation={nation} travelData={data} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
